import React, { useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  BooleanInput,
  Create,
  ReferenceInput,
  AutocompleteInput,
  SelectArrayInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
  required,
} from "react-admin";
import { NavigationTypeEnum, RoleEnum, StatusEnum } from "src/common/enum";
import Transformer from "src/common/Transformer";
import { NavigationItemsContext } from "./NavigationItemsList";
import { FileInput } from "../../../components/file-input/FileInput";
import { Grid, TextField } from "@mui/material";

export function NavigationItemsCreate() {
  const { currentParent } = useContext(NavigationItemsContext);
  const dataProvider = useDataProvider();
  const { navigationId } = useParams();

  const notify = useNotify();
  const refresh = useRefresh();

  const [type, setType] = React.useState("");
  const [reference, setReference] = React.useState("");
  const [optionText, setOptionText] = React.useState("");
  const [entity, setEntity] = React.useState("");
  const [title, setTitle] = React.useState("");

  useEffect(() => {
    setOptionText("title");
    if (type === "page") {
      setReference("admin/pages");
    } else if (type === "article") {
      setReference("admin/articles");
    } else if (type === "articleCategory") {
      setReference("admin/article/categories");
      setOptionText("name");
    } else if (type === "product") {
      setReference("admin/products");
      setOptionText("name");
    } else if (type === "productCategory") {
      setReference("admin/product/categories");
      setOptionText("name");
    }
  }, [type]);

  const setTitleAndEntity = (id) => {
    setEntity(id);

    if (type === "productCategory") {
      dataProvider
        .getOne("admin/product/categories", {
          id: id,
        })
        .then((res) => {
          setTitle(res.data.name);
        });
    } else if (type === "articleCategory") {
      dataProvider
        .getOne("admin/article/categories", {
          id: id,
        })
        .then((res) => {
          setTitle(res.data.name);
        });
    } else if (type === "product") {
      dataProvider
        .getOne("admin/products", {
          id: id,
        })
        .then((res) => {
          setTitle(res.data.name);
        });
    } else if (type !== "basic" && type !== "") {
      dataProvider
        .getOne(type + "s", {
          id: id,
        })
        .then((res) => {
          setTitle(res.data.title);
        });
    }
  };

  const transform = async (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "entity"],
      update: {
        openInNewTab:
          data.open_in_new_tab != null
            ? data.open_in_new_tab.toString()
            : "false",
        parent: currentParent ? currentParent.id : null,
        navigation: data.navigation || parseInt(navigationId),
        type: type,
        url: type === "basic" ? data.url : null,
        title: title,
        position: 0,
      },
    });

    if (entity && type !== "basic") {
      data.entity = entity;
    }

    return data;
  };

  const onSuccess = (data) => {
    notify("ra-tree.item_created");
    refresh();
  };

  return (
    <Create transform={transform} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <SelectInput
              source="type"
              validate={required()}
              choices={NavigationTypeEnum}
              onChange={(e) => {
                setType(e.target.value);
              }}
            />
          </Grid>

          {type !== "basic" && type !== "" ? (
            <Grid item sm={12} lg={8}>
              {reference !== "" ? (
                <ReferenceInput source="entity" reference={reference}>
                  <AutocompleteInput
                    filterToQuery={(search) => ({ search })}
                    onChange={(e) => setTitleAndEntity(e)}
                    size="small"
                    optionText={optionText}
                  />
                </ReferenceInput>
              ) : null}
            </Grid>
          ) : null}

          <Grid item sm={12} lg={8}>
            <TextField
              variant="outlined"
              label="Title"
              required
              size="small"
              onChange={(e) => setTitle(e.target.value)}
              sx={{ width: "100%", marginBottom: "24px" }}
              value={title}
            />
          </Grid>
          {type === "basic" ? (
            <Grid item sm={12} lg={8}>
              <TextInput source="url" />
            </Grid>
          ) : null}

          <Grid item sm={12} lg={8}>
            <TextInput
              source="description"
              multiline
              resettable
              sx={{
                textarea: { minHeight: "90px" },
              }}
            />
          </Grid>
          <Grid item sm={12} lg={8}>
            <FileInput
              label="Image"
              source="image"
              fileTypes={["JPG", "PNG", "GIF", "MP4"]}
              multiple={false}
              path="admin/media/common"
            />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput
              validate={required()}
              source="status"
              choices={StatusEnum}
            />
          </Grid>
          <Grid item sm={12} lg={8}>
            <BooleanInput source="open_in_new_tab" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectArrayInput source="visible_by_roles" choices={RoleEnum} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
}
